import Vue from "vue";
import { API } from "aws-amplify";
import { bodyWithAuthHeader, handleHttpError } from "../utils/utils";
import { VehicleShop } from "../model/vehicle-shop.model";

const API_PATH = "/vehicles/vehicle-shop";

const locService = Vue.prototype.$localizationService;

export default {
  name: "vehicleShopsModule",
  namespaced: true,

  state: {
    pageLoading: false,
    displayVehicleShops: [],
    currentPage: {
      vehicleShops: [],
      index: 0,
      size: 25,
    },
    totalCount: 0,
  },

  mutations: {

    startLoadingPage(state, currentPage) {
      state.pageLoading = true;
      state.currentPage = currentPage;
    },

    endLoadingPage(state) {
      state.pageLoading = false;
    },

    updateTotalCount(state, totalCount) {
      state.totalCount = totalCount;
    },

    updateVehicleShops(state, vehicleShopDto) {
      state.currentPage.vehicleShops = [...vehicleShopDto];
      state.displayVehicleShops = state.currentPage.vehicleShops;
    },
  },

  actions: {

    async loadPage({ dispatch, commit }, currentPage) {
      commit("startLoadingPage", currentPage);

      await dispatch("loadTotalCount");
      const body = {
        ...await bodyWithAuthHeader(),
        queryStringParameters: {
          page: currentPage.index,
          pageSize: currentPage.size,
          sort: currentPage.sort.join("+"),
          searchString: currentPage.searchString,
        },
      };

      try {
        const vehicleShopsDto = await API.get("core", API_PATH, body);
        commit("updateVehicleShops", vehicleShopsDto.map((vehicleShop) => VehicleShop.fromDto(vehicleShop)));
      } catch (e) {
        handleHttpError(e);
      }
      commit("endLoadingPage");
    },

    async loadTotalCount({ commit, state }) {
      const body = {
        ...await bodyWithAuthHeader(),
        queryStringParameters: {
          searchString: state.currentPage.searchString,
        },
      };

      try {
        const count = await API.get("core", `${API_PATH}/count`, body);
        commit("updateTotalCount", count);
      } catch (e) {
        handleHttpError(e);
      }
    },

    reloadPage({ dispatch, state }) {
      dispatch("loadPage", state.currentPage);
    },

    async addOrSaveVehicleShop(context, vehicleShop) {
      const body = { ...await bodyWithAuthHeader(), body: vehicleShop };

      try {
        const shop = await (vehicleShop.id ? API.put("core", `${API_PATH}/${vehicleShop.id}`, body)
          : API.post("core", API_PATH, body));
        const shopDto = VehicleShop.fromDto(shop);
        Vue.toasted.success(
          locService.localize(vehicleShop.id ? "store.vehicle_shop.save_vehicle_shop_msg"
            : "store.vehicle_shop.add_vehicle_shop_msg", [vehicleShop.name]),
          {
            duration: 5000,
          },
        );
        return shopDto;
      } catch (e) {
        handleHttpError(e);
      }
      return undefined;
    },

    async deleteVehicleShop(context, vehicleShop) {
      const body = await bodyWithAuthHeader();

      try {
        await API.del("core", `${API_PATH}/${vehicleShop.id}`, body);
        Vue.toasted.success(locService.localize("store.vehicle_shop.delete_vehicle_shop_msg",
          [vehicleShop.name]), {
          duration: 5000,
        });
      } catch (e) {
        handleHttpError(e);
      }
    },

    async loadFilteredVehicleShops(context, searchString) {
      if (!searchString) return [];

      try {
        return await API.get("core", `${API_PATH}/search?searchString=${searchString}`,
          await bodyWithAuthHeader());
      } catch (error) {
        handleHttpError(error);
      }
      return undefined;
    },

    async loadAllVehicleShops() {
      try {
        return await API.get("core", `${API_PATH}`, await bodyWithAuthHeader());
      } catch (error) {
        handleHttpError(error);
      }
      return undefined;
    },
  },
};
